import { Backdrop, Fade, makeStyles, Theme } from '@material-ui/core'
import React, { FC } from 'react'
import { BivialLoader } from './BivialLoader'
import { useReactiveVar } from '@apollo/client'
import { globalLoadingData } from '../../graphql/local'

const useStyles = makeStyles((theme: Theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    pointerEvents: 'none',
  },
}))

export const LoaderContainer: FC = () => {
  const classes = useStyles()
  const isDataLoading = useReactiveVar(globalLoadingData)

  return (
    <Fade in={isDataLoading} timeout={500}>
      <Backdrop className={classes.backdrop} open={isDataLoading}>
        <BivialLoader />
      </Backdrop>
    </Fade>
  )
}
